import React, { Component } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  TextField,
  MenuItem,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import FullscreenExitIcon from "@material-ui/icons/FullscreenExit";
import axios from "axios";
import SearchIcon from "@material-ui/icons/Search";
import RefreshIcon from "@material-ui/icons/Refresh";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { fi } from "date-fns/locale";

const email = (localStorage.getItem("email") || "").toLowerCase();
const reportTypeMap = {
  transaction: {
    label: "Transaction Report",
    route: "DataTable",
    filter: true,
  },

  delinquency: {
    label: "Delinquency Report",
    route: "DeliquencyTable",
    filter: false,
  },

  ageAudit: {
    label: "Age Audit Report",
    route: "AgeAudit",
    filter: false,
  },

  ageUp: {
    label: "Age-Up Report",
    route: "AgeUp",
    filter: true,
  },

  recurringTransaction: {
    label: "Recurring Transaction Audit",
    route: "RecurringTransaction",
    filter: false,
  },

  quickQuote: {
    label: "Quick Quote Report",
    route: "QuickQuote",
    filter: true,
  },
};

const searchByOptions = [
  {
    value: "date",
    label: "Date",
  },
];

class OperationsReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedReport: "transaction",
      iframeURL: "",
      showDialog: true,
      isFullscreen: false,
      fromDate: null,
      toDate: null,
      searchBy: "date",
      reports: reportTypeMap,
    };
  }

  componentDidMount() {
    this.getAdminCards(localStorage.getItem("email")).then(() => {
      this.generateReportURL(this.state.selectedReport);
    });
  }

  getAdminCards = (email) => {
    return axios
      .get(
        `${process.env.REACT_APP_CARDS_URL}/admin/cards/${email}/ADMIN/NETWELL`,
      )
      .then((resp) => {
        let reports = [];

        try {
          reports =
            JSON.parse(resp.data.response.metadata || "{}").reports || [];
        } catch (err) {
          console.error("Invalid metadata:", err);
        }

        const updatedReportTypeMap = Object.fromEntries(
          Object.entries(reportTypeMap).filter(([_, value]) =>
            reports.includes(value.label),
          ),
        );

        this.setState({
          reports: updatedReportTypeMap,
          selectedReport: Object.keys(updatedReportTypeMap)[0] || "transaction",
        });
      });
  };

  handleReportChange = (event) => {
    const selectedReport = event.target.value;

    this.setState(
      {
        fromDate: null,
        toDate: null,
        selectedReport: selectedReport,
      },
      () => this.generateReportURL(selectedReport),
    );
  };

  encryptMemberId = async (encodeString) => {
    try {
      const request = {
        memberId: encodeString,
      };

      const netwellOrganization = Buffer.from(`NETWELL;${new Date()}`).toString(
        "base64",
      );

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}v1/csrportal/idencryption`,
        request,
        {
          headers: {
            "X-Tenant-Id": netwellOrganization,
            Authorization:
              "Bearer " + localStorage.getItem("NetwellbearerToken"),
          },
        },
      );

      return encodeURIComponent(response.data);
    } catch (err) {
      console.error(err);
      return "";
    }
  };

  encryptData = async (request) => {
    return await this.encryptMemberId(request);
  };

  generateReportURL = async (reportKey) => {
    const report = this.state.reports[reportKey];

    if (!report) {
      return;
    }

    const reportRoute = report.route;
    const memberId = localStorage.getItem("sourceid");
    const email = localStorage.getItem("email");
    const token = localStorage.getItem("NetwellbearerToken");

    const request = `memberid=${memberId}&type=&email=${email}&fromDate=${this.state.fromDate}&toDate=${this.state.toDate}`;

    const query = await this.encryptData(request);

    const iframeURL = `${process.env.REACT_APP_SHARED_MODULE_URL}${reportRoute}?query=${query}&token=${token}`;

    this.setState({
      iframeURL,
    });
  };

  handleSearch = () => {
    const { selectedReport, fromDate, toDate } = this.state;

    this.generateReportURL(selectedReport, fromDate, toDate);
  };

  handleReset = () => {
    this.setState(
      {
        fromDate: null,
        toDate: null,
        selectedReport: "transaction",
      },
      () => this.generateReportURL(this.state.selectedReport),
    );
  };

  handleClose = () => {
    this.setState({
      showDialog: false,
    });

    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  toggleFullscreen = () => {
    this.setState((prevState) => ({
      isFullscreen: !prevState.isFullscreen,
    }));
  };

  render() {
    const { selectedReport, iframeURL, showDialog, isFullscreen } = this.state;

    return (
      <Dialog
        open={showDialog}
        fullWidth
        maxWidth="lg"
        fullScreen={isFullscreen}
        onClose={(_, reason) => {
          if (reason !== "backdropClick") {
            this.handleClose();
          }
        }}
      >
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            Operations Report
            <Box>
              <IconButton onClick={this.toggleFullscreen}>
                {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
              </IconButton>

              <IconButton onClick={this.handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        </DialogTitle>

        <DialogContent
          style={{
            background: "#f5f5f5",
            flex: "unset",
            padding: 0,
          }}
        >
          {Object.keys(this.state.reports).length === 0 ? (
            <Box p={3} textAlign="center">
              <h3>This user does not have access to any reports.</h3>
            </Box>
          ) : (
            <>
              <Box
                display="flex"
                alignItems="center"
                flexWrap="wrap"
                gridGap={16}
                style={{ padding: isFullscreen ? 16 : 20 }}
              >
                {/* Report */}
                <TextField
                  select
                  label="Select Report"
                  variant="outlined"
                  value={selectedReport}
                  onChange={this.handleReportChange}
                  style={{
                    width: 260,
                    backgroundColor: "#fff",
                  }}
                >
                  {Object.entries(this.state.reports).map(([key, report]) => (
                    <MenuItem key={key} value={key}>
                      {report.label}
                    </MenuItem>
                  ))}
                </TextField>
                {this.state.reports[selectedReport]?.filter && (
                  <>
                    {/* Search By */}
                    <TextField
                      select
                      label="Search By"
                      variant="outlined"
                      value={this.state.searchBy}
                      onChange={(e) =>
                        this.setState({ searchBy: e.target.value })
                      }
                      style={{
                        width: 180,
                        backgroundColor: "#fff",
                      }}
                    >
                      {searchByOptions.map((item) => (
                        <MenuItem key={item.value} value={item.value}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </TextField>

                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <Box display="flex" gridGap={16}>
                        <KeyboardDatePicker
                          autoOk
                          variant="inline"
                          inputVariant="outlined"
                          format="MM/dd/yyyy"
                          label="From Date"
                          value={this.state.fromDate}
                          onChange={(date) => this.setState({ fromDate: date })}
                          invalidLabel=""
                          invalidDateMessage=""
                          inputProps={{
                            placeholder: "MM/DD/YYYY",
                          }}
                          style={{
                            width: 180,
                            backgroundColor: "#fff",
                          }}
                        />

                        <KeyboardDatePicker
                          autoOk
                          variant="inline"
                          inputVariant="outlined"
                          format="MM/dd/yyyy"
                          label="To Date"
                          value={this.state.toDate}
                          minDate={this.state.fromDate}
                          disabled={!this.state.fromDate}
                          onChange={(date) => this.setState({ toDate: date })}
                          invalidLabel=""
                          invalidDateMessage=""
                          inputProps={{
                            placeholder: "MM/DD/YYYY",
                          }}
                          style={{
                            width: 180,
                            backgroundColor: "#fff",
                          }}
                        />
                      </Box>
                    </MuiPickersUtilsProvider>

                    {/* Search */}
                    <IconButton
                      onClick={this.handleSearch}
                      disabled={!this.state.fromDate || !this.state.toDate}
                      style={{
                        color: "#fff",
                        backgroundColor:
                          !this.state.fromDate || !this.state.toDate
                            ? "lightgray"
                            : "#fb6647",
                      }}
                    >
                      <SearchIcon />
                    </IconButton>

                    {/* Reset */}
                    <IconButton
                      onClick={this.handleReset}
                      disabled={!this.state.fromDate && !this.state.toDate}
                      style={{
                        color: "#fff",
                        backgroundColor:
                          !this.state.fromDate && !this.state.toDate
                            ? "lightgray"
                            : "#fb6647",
                      }}
                    >
                      <RefreshIcon />
                    </IconButton>
                  </>
                )}
              </Box>

              <Box
                style={{
                  height: isFullscreen ? "calc(100vh - 180px)" : "450px",
                  overflow: "hidden",
                }}
              >
                {iframeURL && (
                  <iframe
                    title={this.state.reports[selectedReport]?.label}
                    src={iframeURL}
                    width="100%"
                    height="117%"
                    frameBorder="0"
                    style={{
                      border: "none",
                    }}
                  />
                )}
              </Box>
            </>
          )}
        </DialogContent>
      </Dialog>
    );
  }
}

export default OperationsReport;
